module.exports = __webpack_public_path__ + "static/phone-slide-1-en-4b625c720d09697507d9a1ff6ea06efd.png";